export const loadsTabModes = {
  CHARACTERISTICS: 'characteristics',
  DESIGN: 'design',
};



// WEBPACK FOOTER //
// ./src/reducers/selectors/loads/loadsTabModes.js